module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/201/assets/images/b1fcdf162bdecb2fe66ae4abc827c874.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_pass_hide_hover.svg
// module id = OHZ+
// module chunks = 1